import type { MessageDescriptor } from 'react-intl';
import { FormattedMessage } from 'react-intl';

import { FullWidthContainer } from '#src/atoms/layout/FullWidthContainer/index.tsx';
import { Tab, TabBar } from '#src/atoms/navigation/TabBar/index.tsx';
import { SEARCH_PARAMS } from '#src/components/search/InstantSearch/types.tsx';
import { buildFilterQuery } from '#src/components/search/InstantSearch/utils.ts';
import { useSettlableWalletsSearch } from '#src/hooks/useSettlableWalletsSearch.ts';
import { glossary, navLabels } from '#src/lib/glossary.ts';

type Props = {
  tabs: Partial<Record<TeamPageTabs, string>>;
};

export enum TeamPageTabs {
  OVERVIEW = 'OVERVIEW',
  STANDINGS = 'STANDINGS',
  FIXTURES = 'FIXTURES',
  TEAM = 'TEAM',
  CARDS = 'CARDS',
}

const tabsTitle: Record<TeamPageTabs, MessageDescriptor> = {
  [TeamPageTabs.OVERVIEW]: navLabels.overview,
  [TeamPageTabs.STANDINGS]: navLabels.standings,
  [TeamPageTabs.FIXTURES]: navLabels.fixtures,
  [TeamPageTabs.TEAM]: navLabels.team,
  [TeamPageTabs.CARDS]: glossary.cards,
};

export const Tabs = ({ tabs }: Props) => {
  const tabsToDisplay = Object.keys(tabs) as TeamPageTabs[];
  const defaultSettlementWallets = useSettlableWalletsSearch();

  return (
    <FullWidthContainer.NoPadding>
      <TabBar variant="flat" fullWidth>
        {tabsToDisplay.map(tab => (
          <Tab
            key={tab}
            to={
              tab === TeamPageTabs.CARDS
                ? `${tabs[tab]}?${buildFilterQuery({
                    [SEARCH_PARAMS.ON_SALE]: true,
                    ...(defaultSettlementWallets
                      ? {
                          [SEARCH_PARAMS.PURCHASE_OPTIONS]:
                            defaultSettlementWallets,
                        }
                      : {}),
                  })}`
                : tabs[tab]
            }
          >
            <FormattedMessage {...tabsTitle[tab]} />
          </Tab>
        ))}
      </TabBar>
    </FullWidthContainer.NoPadding>
  );
};
